import './FeatureUpdate.css';

import React, { Component } from 'react';

import { Button, Form, Header, Icon, Modal } from 'semantic-ui-react';
import NumberInput from 'semantic-ui-react-numberinput';


class FeatureUpdate extends Component {

    state = {
        modalOpen: false,
        isSectored: this.props.feature.is_sector,
        numSectors: this.props.feature.sector_nodes,
    }

    handleOpen = () => this.setState({ modalOpen: true })

    handleClose = () => this.setState({ modalOpen: false })

    handleSave = (e) => {
        this.props.handleSubmit(e, this.state.numSectors);
        this.setState({ modalOpen: false });
    }

    setNumSectors = (num) => {
        this.setState({ numSectors: parseInt(num) });
    }

    setIsSectored = (e) => this.setState({ isSectored: e.target.checked })

    validateAzimuth(e) {
        if (e.target.value > 359 || e.target.value < 0) {
            e.target.value = 0;
        }
    }

    validateName(e) {
        const invalid_chars =  ['^', '/', '>', '<', ',', ';', '|'];
        const is_invalid = invalid_chars.some(c => e.target.value.includes(c));
        if (is_invalid) {
            e.target.setCustomValidity("Site name cannot contains any of the following characters: ^ / > < , ; |");
        } else {
            e.target.setCustomValidity("");
        }
    }

    getSectorTexts = () => {
        const text_sectors = [];
        const azimuth_range = 360 / this.state.numSectors;

        for (let i = 0; i < this.state.numSectors; i++) {
            let azimuth = i * azimuth_range;
            if (this.props.feature.azimuths[i]) {
                azimuth = this.props.feature.azimuths[i];
            }
            text_sectors.push(
                <Form.Field key={`sector_${i}`}>
                    <label>{`Sec: ${i}`}</label>
                    <input
                        id={`input_sector_${i}`}
                        type="number"
                        min="0"
                        max="359"
                        defaultValue={azimuth}
                        onChange={this.validateAzimuth}
                        key={`input_${this.state.numSectors}_${i}`}
                        disabled={!this.state.isSectored}
                    />
                </Form.Field>
            )
        };
        return text_sectors;
    }

    render() {
        if (!this.props.feature || !this.props.configuration) {
            return <div>Loading...</div>;
        }

        return (
            <Modal
                className="modal"
                closeIcon={{ style: { top: '1.0535rem', right: '1rem' }, color: 'black', name: 'close' }}
                trigger={<button
                    className="ui icon button mini"
                    data-tooltip="Edit this site"
                    data-inverted=""
                    disabled={this.props.disabled}
                    onClick={this.handleOpen}>
                    <i aria-hidden="true" className="edit icon small"></i></button>
                }
                open={this.state.modalOpen}
                onClose={this.handleClose}
            >
                <Header icon='wifi' content='Update Site' />
                <Modal.Content>

                    <Form onSubmit={this.handleSave}>
                        <Form.Field>
                            <input id="feat_pk"
                                placeholder={this.props.feature.pk}
                                defaultValue={this.props.feature.pk}
                                hidden
                            />
                        </Form.Field>
                        <Form.Field>
                            <input id="feat_geom"
                                placeholder={this.props.feature.geom}
                                defaultValue={this.props.feature.geom}
                                hidden
                            />
                        </Form.Field>
                        <Form.Field>
                            <input id="feat_collection_version"
                                placeholder={this.props.feature.collection_version}
                                defaultValue={this.props.feature.collection_version}
                                hidden
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>Site Name</label>
                            <input id="feat_name"
                                placeholder={this.props.feature.name}
                                defaultValue={this.props.feature.name}
                                pattern="[^/><,;|]+"
                                onChange={this.validateName}
                            />
                        </Form.Field>

                        <div className="ui segment">

                            <Form.Field>
                                <label>Apply these options to all the sites for this collection</label>
                                <input id="apply_all"
                                    type="checkbox"
                                    defaultChecked={false}
                                />
                            </Form.Field>

                            <Form.Field>
                                <label>Site Height ({this.props.profile.units_length_string})</label>
                                <input id="feat_height"
                                    type="number"
                                    placeholder={this.props.feature.height_local}
                                    defaultValue={this.props.feature.height_local}
                                />
                            </Form.Field>

                            <Form.Field>
                                <label>Transmit Power ({this.props.profile.units_power_string})</label>
                                <input id="feat_txpwr"
                                    placeholder={this.props.feature.txpwr_local ? this.props.feature.txpwr_local : this.props.configuration.txpwr_local}
                                    defaultValue={this.props.feature.txpwr_local ? this.props.feature.txpwr_local : this.props.configuration.txpwr_local}
                                />
                            </Form.Field>

                            <Form.Group inline>
                                <Form.Field>
                                    <label>Is sector antenna?</label>
                                    <input id="is_sector"
                                        type="checkbox"
                                        defaultChecked={this.props.feature.is_sector}
                                        onClick={this.setIsSectored}
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>Number of sectors</label>
                                    <NumberInput
                                        id="sector_nodes"
                                        className="number-input"
                                        disabled={!this.state.isSectored}
                                        minValue={1}
                                        maxValue={10}
                                        value={this.state.numSectors.toString()}
                                        onChange={this.setNumSectors} />
                                </Form.Field>
                            </Form.Group>


                            <Form.Group inline>
                                {this.getSectorTexts()}
                            </Form.Group>

                        </div>

                        <Modal.Actions>
                            <Button color='green' >
                                <Icon name='checkmark' />Save
                            </Button>
                        </Modal.Actions>
                    </Form>
                </Modal.Content>
            </Modal>
        )
    }

}

export default FeatureUpdate;